export { Mascot } from "./Mascot"
export type { MascotProps, MascotName } from "./Mascot"
